import { digObject } from '@domain-group/javascript-utils'
import { Box, DashboardModuleListItem, Tag } from '@domain-group/suit-theme'

import type { TaskListSectionModel } from '@domain-group/realhub-backend-api-types'

import useTaskListSection from '@hooks/useTaskListSection'

interface TaskListSectionProps {
  taskListSection: TaskListSectionModel,
}

const TaskListSection = (props: TaskListSectionProps) => {
  const { taskListSection } = props

  const taskListSectionPayload = useTaskListSection(taskListSection)
  const {
    taskListSection: { dates, title },
    urls: {
      editTaskListSectionUrl,
    },
  } = taskListSectionPayload

  // @ts-expect-error TS2345
  const dueDate = digObject(dates, 'due.date')

  return (
    <DashboardModuleListItem href={editTaskListSectionUrl} title={title}>
      <Box marginLeft="auto" width="auto">
        {!!dueDate && (
          <Tag
            boxProps={{
              color: 'bodyFontColor',
              display: 'inline-flex',
              fontSize: 'xxsmall',
              fontStyle: 'normal',
              paddingX: 'medium',
              variant: 'whiteGrey',
            }}
            // @ts-expect-error TS2322
            width="auto"
          >
            {dueDate}
          </Tag>
        )}
      </Box>
    </DashboardModuleListItem>
  )
}

export default TaskListSection
